module.exports = __webpack_public_path__ + "img/promote-180.c4ef286.svg";